import { ColDef } from '@ag-grid-community/core';
import i18n from 'i18n';

export type EricssonNeTargetTemplateFormSection = 'EIMSGENERAL' | 'EIMSTARGET' | 'EIMSMCNB' | 'EIMSGPRSTRGT' | 'EIMSWRLNTRGT' | 'EIMSMSCTRGT' | 'EIMSMC';

export type TargetTemplateFormSection =
  | 'main'
  | 'targetInformation'
  | 'callContentChannels'
  | 'callContentType'
  | 'ICD'
  | 'monitoringCenterFlags'
  | 'networkType'
  | 'monitoringCenterNumberInformation'
  | EricssonNeTargetTemplateFormSection
  | 'usnbdTargetInformation'
  | 'usnbdCallContentChannelInformation';

export enum TargetDeliveryTemplateAccessFunctionType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const targetDeliveryTemplateAccessFunctionColumnDefs: ColDef[] = [

  {
    headerName: i18n.t('targetDeliveryTemplateAccessFunction.grid.name'),
    field: 'name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'name',
    flex: 1,
    maxWidth: 200,
  },
  {
    headerName: i18n.t('targetDeliveryTemplateAccessFunction.grid.afName'),
    field: 'afName',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'afName',
    flex: 1,
    maxWidth: 200,
  },
  {
    headerName: i18n.t('targetDeliveryTemplateAccessFunction.grid.afType'),
    field: 'afTypeDisplay',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'afType',
    flex: 1,
    maxWidth: 200,
  }
];
